import { PropsWithChildren, createContext } from "react";
import useNotifications from "../hooks/useNotifications";

type NotificationContextData = ReturnType<typeof useNotifications>;

const NotificationContext = createContext<NotificationContextData>({
  notifications: [],
  notify: () => {},
  dismiss: () => {},
  clear: () => {},
});

const NotificationProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { notifications, notify, dismiss, clear } = useNotifications();

  // Todo: listen to socket events and notify accordingly

  return (
    <NotificationContext.Provider
      value={{
        notifications,
        notify,
        dismiss,
        clear,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export { NotificationContext, NotificationProvider };
